export enum BarcodeScannerEnum {
  HiddenComponents,
  ShowBarcodeScannerComponent,
  ShowUploadFileComponent,
  SendBarcodePdf417Data,
  SendBarcodeQrCodeData
}

export enum BarcodeFormatEnum {
  Pdf417,
  QrCode
}



// WEBPACK FOOTER //
// ./src/app/utils/barcode-scanner/enum/barcode-scanner.enum.ts